import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import Lang from 'Lang/General'
import { Get, Put, Post, Delete } from 'utils/axios-token'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      automations: [],
      selectedScenarioID: null,
      selectedAutomationEmails: [],
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showViewAutomationModal: false,
      query: {
        page: 1,
        is_paginated: true
      },
      showEmailLogsModal: false,
      selectedAutomationEmailLogs: []
    }

    onChangeAutomationHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => toast.error( error )

    getAutomation = () => {
      Get(
        `/api/v1/fex/automation/scenarios/${this.props.data.selectCenterReducer.selectedCenter.center.client_id}`,
        this.getAutomationSuccess,
        this.getAutomationError,
        this.load
      )
    }
    getAutomationSuccess = payload => this.setState({ automations: payload })
    getAutomationError = error => this.requestError( error.toString() )

    getSelectedAutomationEmails = id => {
      Get(
        `/api/v1/fex/automation/scenarios/emails/${id}`,
        payload => this.getSelectedAutomationEmailSuccess(payload, id),
        this.getSelectedAutomationEmailError,
        this.load
      )
    }
    getSelectedAutomationEmailSuccess = (payload, id) => this.setState({ 
      selectedAutomationEmails: _.orderBy(payload, 'id'), 
      showEditModal: true 
    })
    getSelectedAutomationEmailError = error => this.requestError( error )

    updateAutomationEmail = (dataToSubmit) => {
      Put(
        `/api/v1/fex/automation/emails/${dataToSubmit.id}`,
        dataToSubmit,
        () => this.updateAutomationSuccess(dataToSubmit.scenario_id),
        this.updateAutomationError,
        this.load
      )
    }
    updateAutomationSuccess = id => {
      this.requestSuccess( Lang[ 'RECORD_UPDATE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] )
      this.getSelectedAutomationEmails(id)
      this.setState({ 
        showEditModal: false,
        query: {
          page: 1,
          is_paginated: true
        }
      })
    }
    updateAutomationError = error => this.requestError( error )

    postAutomationEmail = (dataToSubmit, cb) => Post(
      `/api/v1/fex/automation/emails`,
      dataToSubmit,
      () => {
        this.getSelectedAutomationEmails(dataToSubmit.scenario_id)
        this.requestSuccess( Lang[ 'RECORD_CREATED_SUCCESSFULLY' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] )
        this.setState({ 
          query: {
            page: 1,
            is_paginated: true
          }
        })
        cb && cb()
      },
      this.postAutomationEmailError,
      this.load
    )
    postAutomationEmailError = error => this.requestError( error )

    updateAutomationScenario = dataToSubmit => Put(
      `/api/v1/fex/automation/scenarios/${dataToSubmit.id}`,
      dataToSubmit,
      this.updateAutomationScenarioSuccess,
      this.updateAutomationScenarioError,
      this.load
    )
    updateAutomationScenarioSuccess = () => this.getAutomation()
    updateAutomationScenarioError = error => this.requestError(error)

    deleteAutomationEmail = (id, scenarioID, cb) => Delete(
      `/api/v1/fex/automation/emails/${id}`,
      () => {
        cb && cb()
        this.getSelectedAutomationEmails(scenarioID)
        this.requestSuccess( Lang[ 'RECORD_DELETE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] )
      },
      this.deleteAutomationEmailError,
      this.load
    )
    deleteAutomationEmailError = error => this.requestError( error )

    getSelectedAutomationEmailLogs = id => Get(
      `/api/v1/fex/automation/scenarios/email_logs/${ id }`,
      this.getSelectedAutomationEmailLogsSuccess,
      this.getSelectedAutomationEmailLogsError,
      this.load
    )
    getSelectedAutomationEmailLogsSuccess = payload => this.setState({ 
      showEmailLogsModal: true,
      selectedAutomationEmailLogs: payload
    })
    getSelectedAutomationEmailLogsError = error => this.requestError( error )
    
    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          { ...this.state }
          onLoadAutomationHOC={ this.state.loading }
          getAutomation={ this.getAutomation }
          deleteAutomationEmail={this.deleteAutomationEmail}
          updateAutomationScenario={this.updateAutomationScenario}
          getSelectedAutomationEmails={ this.getSelectedAutomationEmails }
          updateAutomationEmail={ this.updateAutomationEmail }
          postAutomationEmail={this.postAutomationEmail}
          onChangeAutomationHOC={ this.onChangeAutomationHOC }
          getSelectedAutomationEmailLogs={ this.getSelectedAutomationEmailLogs }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC
